// Reordering is expressed as a whole ordering, never as a delta.
//
// The server takes `ordered_ids` and writes positions 1..n from it, so every
// control below is the same request with a different array — and adding a drag
// interaction later would be another caller of `move`, not another endpoint.

/** Returns a copy of `items` with the entry at `from` relocated to `to`. */
export function move<T>(items: T[], from: number, to: number): T[] {
  if (from === to || to < 0 || to >= items.length) return items

  const next = [...items]
  const [moved] = next.splice(from, 1)
  next.splice(to, 0, moved)
  return next
}

/** The id order that results from moving one entry, ready to send as `ordered_ids`. */
export function reorderedIds<T extends { id: number }>(
  items: T[],
  from: number,
  to: number,
): number[] {
  return move(items, from, to).map((item) => item.id)
}
